import Thanks from '@piconetworks/thank-you'
import withInjection from '@piconetworks/with-injection'

import Gift from 'common/modules/gift'
import Loader from 'common/modules/loader'
import Payment from 'common/modules/payment'
import Plan from 'common/modules/plan'
import Wizard from 'common/modules/wizard'

import xFrame from 'common/xFrame'

import { getSignupFormEmail, accountHasPassword, userIsAuthed } from 'common/modules/selectors'

import { WizardLoading } from 'common/pkgs/WizardRedux'

import AwaitShouldMountHOC from 'common/services/awaitShouldMount'

const mapStateToProps = (state, props) => {
    const isSwitchingPlans = !!state
        ?.wizard
        ?.wizards
        ?.CheckoutWizard
        ?.submit
        ?.payload
        ?.currentPlanTierId

    const payNow = !!state
        ?.wizard
        ?.wizards
        ?.CheckoutWizard
        ?.submit
        ?.payload
        ?.pay_now

    const userEmail = Loader.selectors.userEmail(state)
    const signupEmail = getSignupFormEmail(state)
    const differentSignupEmail = signupEmail ? userEmail !== signupEmail : false

    const completedWizard = props?.router?.query?.completedWizard
    const isWizardPaymentRelated = ['CheckoutWizard', 'DonateWizard'].includes(completedWizard)
    const hasActivePurchase = Loader.selectors.currentPurchaseActive(state)
    const defaultPopup = Loader.selectors.getDefaultPopup(state)

    const popupId = Wizard.selectors.thisWizardPopupId({
        state,
        router: props?.router,
    })

    const customTextUrl = Loader.selectors.getAckPopupCustomTextFileNameById(state, popupId)

    /*
        ShouldMount when the fetching is done.
        Switching plan, active purchase or registration etc.
        will mount ThankYou.
    */
    const shouldMount = !state?.loader?.isFetching
    && (
        !isWizardPaymentRelated
        || (isWizardPaymentRelated && hasActivePurchase)
        || isSwitchingPlans
    )

    return {
        ...props,
        didCreateGift: state.gift.didCreateGift,
        gift: state.gift,
        groupName: Loader.selectors.groupName(state),
        linkColor: Loader.selectors.linkColor(state),
        isSwitchingPlans,
        payNow,
        monetizationTypeIsDonation: Loader.selectors.monetizationTypeIsDonation(defaultPopup),
        monetizationTypeIsGroup: Loader.selectors.monetizationTypeIsGroup(defaultPopup),
        pricingHasMonetization: Loader.selectors.pricingHasMonetization(defaultPopup),
        publisherName: Loader.selectors.publisherName(state),
        publisherUrl: Loader.selectors.publisherUrl(state),
        userFirstName: Loader.selectors.userFirstName(state),
        userVerified: Loader.selectors.userVerified(state),
        userHasPassword: accountHasPassword(state),
        userIsAuthed: userIsAuthed(state),
        shouldMount,
        wizard: state.wizard,
        userEmail,
        differentSignupEmail,
        disableRender: true,
        showLoading: true,
        WizardLoading,
        hasUserLoader: !!state?.loader?.user,
        hasActivePurchase,
        getPlanTexts: (scope) => Loader.selectors.planTexts(state, scope, defaultPopup),
        customTextUrl,
    }
}

const mapDispatchToProps = (dispatch) => ({
    cleanWizardsAndStore: (wizardStore) => {
        dispatch(Gift.creators.initialize())
        dispatch(Payment.creators.initialize())
        dispatch(Plan.creators.initialize())

        Object.keys(wizardStore.wizards).forEach((wizardName) => {
            dispatch(Wizard.creators.deleteWizard({
                payload: {
                    id: wizardName,
                },
            }))
        })
    },
    afterCleanup: ({
        thankYouText = 'Thank you for your continued support',
        isSwitchingPlans,
        payNow,
        customTextUrl,
    }) => {
        if (isSwitchingPlans) {
            xFrame.prompt.showMenuRoute({
                dispatch,
                menuRoute: '/notification/switchPlanSuccess',
                data: {
                    switchNow: payNow,
                },
            })
        } else {
            xFrame.prompt.showThankYou({
                thankYouText,
                dispatch,
                customTextUrl,
            })
        }
    },
})

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
    ...ownProps,
    ...stateProps,
    ...dispatchProps,
    cleanWizardsAndStore: () => {
        const { wizard: wizardStore } = stateProps
        dispatchProps.cleanWizardsAndStore(wizardStore)
    },
    afterCleanup: (params = {}) => {
        const { customTextUrl } = stateProps
        dispatchProps.afterCleanup({
            ...params,
            isSwitchingPlans: stateProps.isSwitchingPlans,
            payNow: stateProps.payNow,
            customTextUrl,
        })
    },
})

const InjectedThanks = withInjection(AwaitShouldMountHOC(Thanks), {
    mapStateToProps,
    mapDispatchToProps,
    mergeProps,
})

export default InjectedThanks
